// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ###   Code For GenOverview Component    ### */

.gen-overview-1,
.gen-overview-2,
.gen-overview-3 {
  height: 30vh;
  min-height: 30vh;
  background-color: white;
  /* color: rgb(29, 26, 26); */
  position: relative;
}

/* ###   Code For GenOverview Container 1 --> Box-1    ### */

.gen-overview-1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8vmax;
  gap: 5vmin;

}

.gen-overview-1 > :first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 1.2vmax;
  width: 45%;

}

.gen-overview-1 > :first-child > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5vmin;
  width: 100%;

}

.gen-overview-1 > :first-child > div > :first-child {
  width: 100%;
}

.gen-overview-1 > :first-child > div > :first-child > progress {
  width: 100%;
  height: 1.1rem !important;
}

.gen-overview-1 > :first-child > div > :last-child {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  width: 100%;
  font-size: 1.8vmin;
  position: relative;
  padding: 0 0.2rem;
}

.gen-overview-1 > :first-child > div > :last-child i {
  font-size: 3vmin;
  color: rgb(98, 92, 92);
}

.gen-overview-1 > :last-child {
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1vmin;
}

.gen-overview-1 > :last-child > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.4vmax;

}

.gen-overview-1 > :last-child > div > :first-child {
  font-size: 2.8vmin;
  font-weight: 500;

}

.gen-overview-1 > :last-child > div > :nth-child(2) {
  font-size: 1.5vmin;
  font-weight: bold;

}

.gen-overview-1 > :last-child > div > :last-child {
  padding: 1vmin 2vmin;
  cursor: pointer;
  border-radius: 18px;
  font-size: 1.5vmin;
}

/* ###   Code For GenOverview Container 1 --> Box-2    ### */

.gen-overview-2 {
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: space-between;
  padding: 1.5vmin 0;
  gap: 1vmin;
}

.gen-overview-2 > :first-child {
}

.gen-overview-2 > :last-child {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.gen-overview-2 > :last-child > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 11vmin;
  width: 11vmin;
  border-radius: 50%;
  border: 4px solid rgb(17, 244, 176);
}
.gen-overview-2 > :last-child > div > :first-child {

  font-size: 2vmin;
  font-weight: 600;
}
.gen-overview-2 > :last-child > div > :last-child {
  font-size: 1.5vmin;
}

/* ###   Code For GenOverview Container 1 --> Box-3    ### */

.gen-overview-3 {
  padding: 2vmin 0.5vmin;
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: space-between;
  position: relative;

}
.gen-overview-3 > :first-child {
  font-size: 1.1vmax;
  padding: 1.5vmin 2vmin;
  border: 4px solid rgb(17, 244, 176);
  border-radius: 25px;
}
.gen-overview-3 > :nth-child(2) {
}

/* .speed-chart-container {
  display: "flex";
  justify-content: "space-evenly";
  flex-wrap: "wrap";
  gap: "2vmax";
  padding: "1vmax 2vmax";
  border: 2px solid blue;
} */

.speed-chart-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two equal-width columns */
  grid-template-rows: auto auto; /* Two rows with automatic height */
}
.speed-chart-wrapper {
  margin: 1rem auto;
  padding: 1rem;
  height: 230px;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* .date-container-2 .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected{
  color: red;
  background-color: red;
}
.date-container-2  li .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected{
  color: red;
  background-color: red;
} */
/* class="MuiFormControl-root css-1lf2uee-MuiFormControl-root" */
/* .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{
 
} */

.generation-overview-responsive-container-1,
.generation-overview-responsive-container-2 {
  height: 30vh;
  width: 100%;
  min-width: 600px;
}
.download-box {
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  right: 0%;
  top: 20px;
}

@media screen and (max-width: 1200px) {
  .generation-overview-responsive-container-1,
  .generation-overview-responsive-container-2 {
    height: 40vh;
  }
}

@media screen and (max-width: 1200px) {
  .gen-overview-1 > :last-child > div > :first-child {
    font-size: 3vmin;
  }

  .gen-overview-1 > :last-child > div > :nth-child(2) {
    font-size: 1.5vmin;
  }

  .gen-overview-1 > :last-child > div > :last-child {
    padding: 0.5vmin 1.5vmin;
    cursor: pointer;
    border-radius: 18px;
    font-size: 2vmin;
  }
}

@media screen and (max-width: 800px) {
  .speed-chart-container {
    grid-template-columns: 1fr; /* Two equal-width columns */
    grid-template-rows: auto auto; /* Two rows with automatic height */
    gap: 1rem;
    margin: 1.5rem 0;
  }

  .speed-chart-wrapper {
  height: 30vh;

  }
}

@media screen and (max-width: 550px) {

  .gen-overview-1,
  .gen-overview-2,
  .gen-overview-3 {
    height: 25vh;
  }
  .gen-overview-1 > :first-child {
    /* border: 2px solid red; */
    gap: 2.5vmax;
  }
  .gen-overview-1 > :last-child > div {
    /* border: 2px solid red; */
    gap: 3vmax;
  }
  .gen-overview-1 {
  }
  .gen-overview-1 > :first-child > div {
  }

  .gen-overview-1 > :last-child > div > :nth-child(2) {
  }

  .gen-overview-1 > :last-child > div > :last-child {
  }
  .gen-overview-2 > :last-child > div {
    height: 10vmax;
    width: 10vmax;
  }
  .gen-overview-3 {
  }
  .gen-overview-3 > :nth-child(2) {
  }
  .gen-overview-3 > :last-child {
  }
  .speed-chart-wrapper {
    /* width: 65%;
    height: 35vh; */
  }
}
@media screen and (max-width: 350px) {
  .speed-chart-wrapper {
    /* width: 100%; */
    /* height: 35vh; */
    /* border: 2px solid red; */
  }

  .download-box {
    right: -50%;
  }
}

/* .css-1rtg91x-MuiDateCalendar-root */
/* MuiDateCalendar-root */

/* .MuiCalendarOrClockPicker-root,
.MuiCalendarOrClockPicker-root > div {
  width: 290px;
}

.MuiCalendarPicker-root {
  width: 250px;
}

.MuiCalendarPicker-root > div:first-child {
  padding-left: 12px;
  padding-right: 8px;
  margin-bottom: 0px;
}

.MuiCalendarPicker-root > div:first-child > div:last-child > div {
  width: 4px;
}

.PrivatePickersSlideTransition-root {
  min-height: 230px;
}

button.MuiPickersDay-root.Mui-selected {
  width: 35px;
  height: 31px;
} */
.MuiDateCalendar-root {
  min-height: 300px !important;
  max-height: 300px !important;
}

.MuiDateCalendar-root {
}
.MuiDateCalendar-root > div {
}

.MuiDateCalendar-root
  > div:last-child
  > div
  > div
  > :last-child
  > :first-child {
  max-height: 200px !important;
  overflow: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/overviewDetail/GenOverView.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mCAAmC;AACrC;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,sBAAsB;EACtB,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;AACA;;AAEA;;;;;;;GAOG;;AAEH;EACE,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,6BAA6B,EAAE,mCAAmC;AACpE;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;AACH,gEAAgE;AAChE;;GAEG;;AAEH;;EAEE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,4BAA4B;IACxD,6BAA6B,EAAE,mCAAmC;IAClE,SAAS;IACT,gBAAgB;EAClB;;EAEA;EACA,YAAY;;EAEZ;AACF;;AAEA;;EAEE;;;IAGE,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;EACA;EACA;EACA;;EAEA;EACA;;EAEA;EACA;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;EACA;EACA;EACA;EACA;EACA;EACA;IACE;mBACe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sCAAsC;AACtC,yBAAyB;;AAEzB;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;AACH;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;AACA;AACA;AACA;;AAEA;;;;;;EAME,4BAA4B;EAC5B,yBAAyB;AAC3B","sourcesContent":["/* ###   Code For GenOverview Component    ### */\n\n.gen-overview-1,\n.gen-overview-2,\n.gen-overview-3 {\n  height: 30vh;\n  min-height: 30vh;\n  background-color: white;\n  /* color: rgb(29, 26, 26); */\n  position: relative;\n}\n\n/* ###   Code For GenOverview Container 1 --> Box-1    ### */\n\n.gen-overview-1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.8vmax;\n  gap: 5vmin;\n\n}\n\n.gen-overview-1 > :first-child {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 1.2vmax;\n  width: 45%;\n\n}\n\n.gen-overview-1 > :first-child > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 1.5vmin;\n  width: 100%;\n\n}\n\n.gen-overview-1 > :first-child > div > :first-child {\n  width: 100%;\n}\n\n.gen-overview-1 > :first-child > div > :first-child > progress {\n  width: 100%;\n  height: 1.1rem !important;\n}\n\n.gen-overview-1 > :first-child > div > :last-child {\n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n  width: 100%;\n  font-size: 1.8vmin;\n  position: relative;\n  padding: 0 0.2rem;\n}\n\n.gen-overview-1 > :first-child > div > :last-child i {\n  font-size: 3vmin;\n  color: rgb(98, 92, 92);\n}\n\n.gen-overview-1 > :last-child {\n  width: 55%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 1vmin;\n}\n\n.gen-overview-1 > :last-child > div {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.4vmax;\n\n}\n\n.gen-overview-1 > :last-child > div > :first-child {\n  font-size: 2.8vmin;\n  font-weight: 500;\n\n}\n\n.gen-overview-1 > :last-child > div > :nth-child(2) {\n  font-size: 1.5vmin;\n  font-weight: bold;\n\n}\n\n.gen-overview-1 > :last-child > div > :last-child {\n  padding: 1vmin 2vmin;\n  cursor: pointer;\n  border-radius: 18px;\n  font-size: 1.5vmin;\n}\n\n/* ###   Code For GenOverview Container 1 --> Box-2    ### */\n\n.gen-overview-2 {\n  display: flex;\n  flex-direction: column !important;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5vmin 0;\n  gap: 1vmin;\n}\n\n.gen-overview-2 > :first-child {\n}\n\n.gen-overview-2 > :last-child {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n.gen-overview-2 > :last-child > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: 11vmin;\n  width: 11vmin;\n  border-radius: 50%;\n  border: 4px solid rgb(17, 244, 176);\n}\n.gen-overview-2 > :last-child > div > :first-child {\n\n  font-size: 2vmin;\n  font-weight: 600;\n}\n.gen-overview-2 > :last-child > div > :last-child {\n  font-size: 1.5vmin;\n}\n\n/* ###   Code For GenOverview Container 1 --> Box-3    ### */\n\n.gen-overview-3 {\n  padding: 2vmin 0.5vmin;\n  display: flex;\n  flex-direction: column !important;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n\n}\n.gen-overview-3 > :first-child {\n  font-size: 1.1vmax;\n  padding: 1.5vmin 2vmin;\n  border: 4px solid rgb(17, 244, 176);\n  border-radius: 25px;\n}\n.gen-overview-3 > :nth-child(2) {\n}\n\n/* .speed-chart-container {\n  display: \"flex\";\n  justify-content: \"space-evenly\";\n  flex-wrap: \"wrap\";\n  gap: \"2vmax\";\n  padding: \"1vmax 2vmax\";\n  border: 2px solid blue;\n} */\n\n.speed-chart-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two equal-width columns */\n  grid-template-rows: auto auto; /* Two rows with automatic height */\n}\n.speed-chart-wrapper {\n  margin: 1rem auto;\n  padding: 1rem;\n  height: 230px;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n/* .date-container-2 .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected{\n  color: red;\n  background-color: red;\n}\n.date-container-2  li .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected{\n  color: red;\n  background-color: red;\n} */\n/* class=\"MuiFormControl-root css-1lf2uee-MuiFormControl-root\" */\n/* .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{\n \n} */\n\n.generation-overview-responsive-container-1,\n.generation-overview-responsive-container-2 {\n  height: 30vh;\n  width: 100%;\n  min-width: 600px;\n}\n.download-box {\n  width: fit-content;\n  position: absolute;\n  right: 0%;\n  top: 20px;\n}\n\n@media screen and (max-width: 1200px) {\n  .generation-overview-responsive-container-1,\n  .generation-overview-responsive-container-2 {\n    height: 40vh;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .gen-overview-1 > :last-child > div > :first-child {\n    font-size: 3vmin;\n  }\n\n  .gen-overview-1 > :last-child > div > :nth-child(2) {\n    font-size: 1.5vmin;\n  }\n\n  .gen-overview-1 > :last-child > div > :last-child {\n    padding: 0.5vmin 1.5vmin;\n    cursor: pointer;\n    border-radius: 18px;\n    font-size: 2vmin;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .speed-chart-container {\n    grid-template-columns: 1fr; /* Two equal-width columns */\n    grid-template-rows: auto auto; /* Two rows with automatic height */\n    gap: 1rem;\n    margin: 1.5rem 0;\n  }\n\n  .speed-chart-wrapper {\n  height: 30vh;\n\n  }\n}\n\n@media screen and (max-width: 550px) {\n\n  .gen-overview-1,\n  .gen-overview-2,\n  .gen-overview-3 {\n    height: 25vh;\n  }\n  .gen-overview-1 > :first-child {\n    /* border: 2px solid red; */\n    gap: 2.5vmax;\n  }\n  .gen-overview-1 > :last-child > div {\n    /* border: 2px solid red; */\n    gap: 3vmax;\n  }\n  .gen-overview-1 {\n  }\n  .gen-overview-1 > :first-child > div {\n  }\n\n  .gen-overview-1 > :last-child > div > :nth-child(2) {\n  }\n\n  .gen-overview-1 > :last-child > div > :last-child {\n  }\n  .gen-overview-2 > :last-child > div {\n    height: 10vmax;\n    width: 10vmax;\n  }\n  .gen-overview-3 {\n  }\n  .gen-overview-3 > :nth-child(2) {\n  }\n  .gen-overview-3 > :last-child {\n  }\n  .speed-chart-wrapper {\n    /* width: 65%;\n    height: 35vh; */\n  }\n}\n@media screen and (max-width: 350px) {\n  .speed-chart-wrapper {\n    /* width: 100%; */\n    /* height: 35vh; */\n    /* border: 2px solid red; */\n  }\n\n  .download-box {\n    right: -50%;\n  }\n}\n\n/* .css-1rtg91x-MuiDateCalendar-root */\n/* MuiDateCalendar-root */\n\n/* .MuiCalendarOrClockPicker-root,\n.MuiCalendarOrClockPicker-root > div {\n  width: 290px;\n}\n\n.MuiCalendarPicker-root {\n  width: 250px;\n}\n\n.MuiCalendarPicker-root > div:first-child {\n  padding-left: 12px;\n  padding-right: 8px;\n  margin-bottom: 0px;\n}\n\n.MuiCalendarPicker-root > div:first-child > div:last-child > div {\n  width: 4px;\n}\n\n.PrivatePickersSlideTransition-root {\n  min-height: 230px;\n}\n\nbutton.MuiPickersDay-root.Mui-selected {\n  width: 35px;\n  height: 31px;\n} */\n.MuiDateCalendar-root {\n  min-height: 300px !important;\n  max-height: 300px !important;\n}\n\n.MuiDateCalendar-root {\n}\n.MuiDateCalendar-root > div {\n}\n\n.MuiDateCalendar-root\n  > div:last-child\n  > div\n  > div\n  > :last-child\n  > :first-child {\n  max-height: 200px !important;\n  overflow: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
